export default __webpack_public_path__ + "static/media/5c.03a73ad3.svg";